module.exports = "<div id=inbox> <title title=\"Sent Items\"></title> <div v-if=$loadingAsyncData class=\"mdl-spinner mdl-js-spinner is-active\"></div> <list v-if=!$loadingAsyncData :mails=mails></list> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/SentItems.vue
 ** module id = 29
 ** module chunks = 0
 **/